import React, { useState, useEffect } from 'react';
// import './ColumnsBarChart.styles.scss';
import ChartComplex from "../ChartComplex/ChartComplex";

const defaultColumnsConfig = [
    [1, 2],
    [5],
    [4, 3],
];

const defaultCategoriesData = [
    {
        id: 1,
        name: 'Breakfast 1',
        color: 1,
        items: [
            {
                name: 'Breakfast bakery',
                value: 10,
                total: 8,
            },
            {
                name: 'Yogurt / parfait / smoothie',
                value: 4,
                total: 2,
            },
            {
                name: 'Breakfast main dishes',
                value: 19,
                total: 17,
            },
        ]
    },
    {
        id: 2,
        name: 'Breakfast 2',
        color: 1,
        items: [
            {
                name: 'Breakfast bakery',
                value: 10,
                total: 8,
            },
            {
                name: 'Yogurt / parfait / smoothie',
                value: 4,
                total: 2,
            },
            {
                name: 'Breakfast main dishes',
                value: 19,
                total: 17,
            },
        ]
    },
    {
        id: 3,
        name: 'Breakfast 3',
        color: 1,
        items: [
            {
                name: 'Breakfast bakery',
                value: 10,
                total: 8,
            },
            {
                name: 'Yogurt / parfait / smoothie',
                value: 4,
                total: 2,
            },
            {
                name: 'Breakfast main dishes',
                value: 19,
                total: 17,
            },
        ]
    },
    {
        id: 4,
        name: 'Breakfast 4',
        color: 1,
        items: [
            {
                name: 'Breakfast bakery',
                value: 10,
                total: 8,
            },
            {
                name: 'Yogurt / parfait / smoothie',
                value: 4,
                total: 2,
            },
            {
                name: 'Breakfast main dishes',
                value: 19,
                total: 17,
            },
        ]
    },
    {
        id: 5,
        name: 'Breakfast 5',
        color: 1,
        items: [
            {
                name: 'Breakfast bakery',
                value: 10,
                total: 8,
            },
            {
                name: 'Yogurt / parfait / smoothie',
                value: 4,
                total: 2,
            },
            {
                name: 'Breakfast main dishes',
                value: 79,
                total: 17,
            },
        ]
    },
];

function ColumnsBarChart({ columnsConfig = defaultColumnsConfig, categories = defaultCategoriesData }) {
    const [maxValue, setMaxValue] = useState(0.0001);

    useEffect(() => {
        let max = 0;
        categories.forEach(({ items }) => {
            items.forEach(({ value, total }) => {
                const values = [value, total].filter(value => value < 100);
                max = Math.max(max, ...values);
            });
        });
        setMaxValue(max);
    }, [categories]);

    const columnsData = columnsConfig.map(
        categoriesIds => categoriesIds.map(
            categoryId => categories.find(category => category.id === categoryId)
        )
    );

    return (
        <div className="complex-chart__content">
            {columnsData.map((categories, colIndex) => (
                <div key={colIndex} className="complex-chart__col">
                    {categories.map(({ id, name, color, items }) => (
                        <ChartComplex
                            key={id}
                            name={name}
                            rowColor={color}
                            items={items}
                            maxValue={maxValue}
                        />
                    ))}
                </div>
            ))}
        </div>
    );
}

export default ColumnsBarChart;